<template>
    <div class="row">
        <!--Title-->
        <div class="text-right col-md-12">
                <el-tooltip content="Actualizar" placement="right">
                    <p-button @click="reloadData()" type="warning" icon round>
                        <i class="fa fa-refresh"></i>
                    </p-button>
                </el-tooltip>   
                <h4 class="title center-title pull-left">Usuarios conectados</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.sessions.loading"
            :can-cancel="false" 
            :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
            :can-cancel="false" 
            :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <!-- <div v-if="tableData && !tableData.length && !this.$apollo.queries.sessions.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        <div class="card-footer text-center">
            
        </div>
        </div> -->
        <!--./Empty state-->
        <!--usuarios data-->
        <div class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de usuarios</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-8">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Busca por nombre, apellido o usuario y presiona enter"
                            v-model="searchQueryForm"
                            v-on:keyup.enter="searchForm"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
                <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Acciones">
                <template slot-scope="props">
                    <el-tooltip content="Cerrar sesión" placement="right">
                        <p-button type="danger" size="sm" icon @click="handleRevoke(props.$index, props.row)">
                            <i class="fa fa-close"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./usuarios data-->
    </div>
    
</template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { sessions } from 'src/api/graphql/queries/auth/AllSessions';
    import { REVOKE_SESSION } from 'src/api/graphql/mutations/auth/RevokeSession';
    import { orderBy , sortBy , find } from 'lodash';
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
            sessions:    {
                query: sessions,
                variables() {
                    return {
                        name: this.searchQueryForm,
                    }
                },                    
                skip() {
                    return this.skipSessionQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    
                    if(data.sessions.edges.length == 0)
                    {
                        this.sessions = [];
                        this.tableData = [];
                    }
                    else
                    {
                        this.setSessions(data.sessions);
                        this.skipSessionQuery = true;
                    }
                    
                },
                // Si encontró algún error.
                error(error) {
                    
                },
            },
        },
        components: {
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip
        },
        computed: {
        // tableData(){
        //   return this.oficinas_array
        // },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
         * Searches through table data and returns a paginated array.
         * Note that this should not be used for table with a lot of data as it might be slow!
         * Do the search and the pagination on the server and display the data retrieved from server instead.
         * @returns {computed.pagedData}
         */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: false,
            skipSessionQuery: true,
            tableData: [],
            sessions: [],
            sessions_array: [],
            addOffice : false,//Bandera de creación de usuarios
            editOffice : false,//Bandera de edición de usuarios
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                id: '',
                code: '',
                name: '',
                email: '',
                regional: '',
                isActive: true
            },
            modelValidations: {
            code: {
                required: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            email: {
                email: true,
                required: true,
                max: 64
            },
            regional: {
                required: true,
            },
            },
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQueryForm: '',
            searchQuery: '',
            propsToSearch: ['fullname', 'username','email','group'],
            tableColumns: [
            {
                prop: 'fullname',
                label: 'Nombre',
                minWidth: 200
            },
            {
                prop: 'username',
                label: 'Nombre Usuario',
                minWidth: 250
            },
            {
                prop: 'email',
                label: 'Correo',
                minWidth: 250
            },
            {
                prop: 'group',
                label: 'Rol',
                minWidth: 250
            },
            {
                prop: 'created',
                label: 'Creado',
                minWidth: 250
            },
            ],
        }
        },
        
        methods: {
            /***
             * Función para setear en la tabla los datos que llegan desde la Regional
             */
            searchForm(){
                if(this.searchQueryForm.length >= 4) {
                    this.skipSessionQuery = false;
                    this.$apollo.queries.sessions.refetch();
                }
                else {
                    this.tableData = []
                }
            },
            /**
             * Función para dar formato de hora
             */
            moment(date) {
                moment.locale('es');
                return moment(date).format('LL, h:mm a');
                // return moment(date).format('LLLL a')
            },
            /***
             * Función para actualizar los datos de las sesiones
             */
            reloadData(){
                this.tableData= [];
                this.sessions= [];
                if(this.searchQueryForm.length >= 4) {
                    this.skipSessionQuery = false;
                    this.$apollo.queries.sessions.refetch();
                }
                else {
                    this.tableData = []
                }
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la Sesión
             */
            setSessions(sessions){
                var vm = this;
                vm.tableData = [];
                for(let i=0;i<sessions.edges.length;i++)
                {
                    vm.pushSessionsData(sessions.edges[i].node);
                }
                vm.orderSessionsData();
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            /*** 
            * Función que se dispara cuando se da clic en revocar sesión
            */
            handleRevoke (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, cerrarás la sesión seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, cerrar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    this.isSending = true;
                    var id = vm.idDecode(row.session_id);
                    this.$apollo.mutate({
                        mutation: REVOKE_SESSION,
                        variables : {
                            input :  {
                                    session : id,
                                }
                        }
                    }).then((data) => {
                        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.session_id === row.session_id)
                        if (indexToDelete >= 0) {
                        this.tableData.splice(indexToDelete, 1)
                        }
                        this.isSending = false;
                        swal({
                        title: '¡Desactivado!',
                        text: 'La sesión seleccionada ha sido cerrada',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                        }).then(() => {
                            vm.reloadData();
                        },function (dismiss){
                            vm.reloadData();
                        });
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'La sesión no ha sido cerrada',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            
            /***
            * Función para agregar un objeto al arreglo de datos de sesiones
            */
            pushSessionsData(node){
                var vm = this;
                vm.tableData.push({
                    session_id: node.id,
                    fullname: node.user.name+' '+node.user.surname,
                    username: node.user.username,
                    email: node.user.email,
                    group: node.user.group.name,
                    created: vm.moment(node.created)
                });
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderSessionsData(){
                var vm = this;
                const myOrderedArray = _.orderBy(vm.tableData, ['created'], ['desc']);
                vm.tableData = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
             * Función para validar el formulario de edición y creación que se envía
             */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    if(vm.addOffice && !vm.editOffice)
                    {
                        var regional_id = vm.idDecode(vm.model.regional);
                        formInput = {
                                code: vm.model.code,
                                name: vm.model.name,
                                email: vm.model.email,
                                regional: regional_id,
                                isActive: true
                        };
                        formMessage = "Oficina registrada con éxito";
                    }
                    else if(!vm.addOffice && vm.editOffice)
                    {
                        var id = vm.idDecode(vm.model.id);
                        var regional_id = vm.idDecode(vm.model.regional);
                        formInput = {
                                id: id,
                                code : vm.model.code,
                                email : vm.model.email,
                                name : vm.model.name,
                                regional : regional_id,
                                isActive: vm.model.isActive
                        };
                        formMessage = "Oficina editada con éxito";
                    }
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: CREATE_OFFICE,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if(!vm.addOffice && vm.editOffice)
                        {
                            let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === vm.rowEdit.id)
                            if (indexToDelete >= 0) {
                            vm.tableData.splice(indexToDelete, 1)
                            }
                        }
                        vm.pushData(data.data.office.office);
                        vm.orderData();
                        vm.isSending = false;
                        vm.onSuccess(formMessage);
                        vm.reloadData();
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                })
        }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
